import $ from 'jquery';
export default function getZIndex(element) {
  let elem = $(element); // eslint-disable-line ember/no-jquery
  let maxZIndex = 0;
  while (elem.length > 0 && !elem.is('.ember-application')) {
    const zIndex = elem.css('z-index');
    // eslint-disable-next-line unicorn/prefer-number-properties -- TODO: try enabling this separately
    if (!isNaN(zIndex)) {
      const position = elem.css('position');
      if (position !== 'static') {
        maxZIndex = Math.max(maxZIndex, Number(zIndex));
      }
    }
    elem = elem.parent();
  }
  if (maxZIndex) {
    return maxZIndex;
  } else {
    return null;
  }
}